import React, { useMemo } from "react";
import moment from "moment";
import { Avatar } from 'Components';

export const AvatarChat = React.memo(({ user, channel, width, showStatusIcon }) => {
    // Memoize color calculation to avoid redundant moment() calls
    const color = useMemo(() => {
        if (!user?.lastConnected) {
            return 'offline';
        }

        const now = moment();
        
        // Check last connected time
        if (now.diff(moment(user.lastConnected), 'minute') < 3) {
            return 'chatConnected';
        }

        // Check writing status
        if (user?.lastWriting) {
            const writingStatusSplit = user.lastWriting.split('|');
            if (
                writingStatusSplit[0] === channel?.id && 
                now.diff(moment(writingStatusSplit[1]), 'second') < 30
            ) {
                return 'chatConnected';
            }
        }

        return 'chatConnected';
    }, [user?.lastConnected, user?.lastWriting, channel?.id]);

    const isOnline = useMemo(() => color === 'chatConnected', [color]);

    return (
        <div>
            <Avatar
                name={user?.label}
                fileKey={user?.avatarFile?.fileKey}
                width={50}
                color={color}
                isOnline={isOnline}
                showStatusIcon={showStatusIcon}
                onClick={() => {}}
            />
        </div>
    );
});